import { FC } from "react";
import { Display } from "stentor-models";

import "./ChatScheduleWidget.scss";
import { useSelector } from "react-redux";
import { useOpenUrlCallback } from "../../hooks/useOpenUrlCallback";
import { ChatState, VisualState } from "../../store/ChatState";
import { useChatDispatch } from "../../utils/useChatDispatch";
import { scheduleWidgetUrl } from "../../config";

export interface Props {
    readonly display: Display;
    minimizeOnClick?(): void;
}

const ChatScheduleWidget: FC<Props> = (props) => {
    const display = props.display as any;

    const chatDispatch = useChatDispatch();
    const visuals = useSelector<ChatState, VisualState>((state) => state.visuals);

    const openUrl = useOpenUrlCallback();

    function handleClick() {
        openUrl(scheduleWidgetUrl, chatDispatch, visuals);
    }

    return (
        <div className="chat-schedule-button-container">
            <button className="chat-schedule-button" onClick={handleClick}>
                <i className="fa fa-lg fa-calendar"></i>
                <span>{display.label || "Schedule Now!"}</span>
            </button>
        </div>
    );
};

export default ChatScheduleWidget;
